import { api, unwrap, type components } from '@/shared/api'

type AuthResponse = components['schemas']['AuthResponse']
type MfaChallenge = components['schemas']['MfaChallengeResponse']

export function isMfaChallenge(response: AuthResponse | MfaChallenge): response is MfaChallenge {
  return 'challengeToken' in response && typeof response.challengeToken === 'string'
}

function browserTimezone(): string | null {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? null
  } catch {
    return null
  }
}

export const authApi = {
  login: (email: string, password: string) =>
    unwrap(api.POST('/api/v1/auth/login', { body: { email, password, tokenDelivery: 'cookie' } })),

  loginMfa: (challengeToken: string, code: { code?: string; recoveryCode?: string }) =>
    unwrap(
      api.POST('/api/v1/auth/login/mfa', {
        body: { challengeToken, ...code, tokenDelivery: 'cookie' },
      }),
    ),

  setupStatus: () => unwrap(api.GET('/api/v1/setup/status')),

  setup: (body: { displayName: string; email: string; password: string }) =>
    unwrap(api.POST('/api/v1/setup', { body: { ...body, timezone: browserTimezone() } })),

  forgotPassword: (email: string) =>
    unwrap(api.POST('/api/v1/auth/password/forgot', { body: { email } })),

  resetPassword: (token: string, newPassword: string) =>
    unwrap(api.POST('/api/v1/auth/password/reset', { body: { token, newPassword } })),

  invitation: (token: string) =>
    unwrap(api.GET('/api/v1/invitations/{token}', { params: { path: { token } } })),

  /** Новый пользователь задаёт имя и пароль, вошедший принимает без тела запроса. */
  acceptInvitation: (token: string, account?: { displayName: string; password: string }) =>
    unwrap(
      api.POST('/api/v1/invitations/{token}/accept', {
        params: { path: { token } },
        ...(account === undefined ? {} : { body: { ...account, timezone: browserTimezone() } }),
      }),
    ),

  me: () => unwrap(api.GET('/api/v1/me')),
}
